import { DateTime } from "luxon";
import type { SingleDateRangeValue } from "../DateRangeInput";

interface GetStartMaximumParams {
  tempEnd: SingleDateRangeValue;
  startInputPropMax?: DateTime;
}

function getStartMaximum({
  tempEnd,
  startInputPropMax
}: GetStartMaximumParams): DateTime | undefined {
  const startMaxCandidates = [tempEnd, startInputPropMax].filter(
    (d): d is DateTime => d !== undefined && d !== null
  );
  return DateTime.min(...startMaxCandidates);
}

export { getStartMaximum };
